import priseencharge from './priseencharge';
import conges from './conges';
import todolist from './todolist';
import jypense from './todolist/jypense';
import examens from './todolist/examens';
import rendezvousmedicaux from './todolist/rendezvousmedicaux';
import bienvivremagrossesse from './articles/bienvivremagrossesse';
import arriveedebebe from './articles/arriveedebebe';
import subheader from './subheader';
import articles from './articles';
import calendrier from './calendrier';

export default {
	priseencharge,
	conges,
	todolist,
	examens,
	rendezvousmedicaux,
	jypense,
	subheader,
	bienvivremagrossesse,
	articles,
	calendrier,
	arriveedebebe
};
